import { createContext } from 'react';

import { Services2, services2 } from './services2';

export interface IServicesContextProps {
  services2: Services2;
}

export const ServicesContext = createContext<IServicesContextProps>({
  services2,
});
